import { render } from "./EthiopiaPage.vue?vue&type=template&id=91b41520&scoped=true"
import script from "./EthiopiaPage.vue?vue&type=script&lang=js"
export * from "./EthiopiaPage.vue?vue&type=script&lang=js"

import "./EthiopiaPage.vue?vue&type=style&index=0&id=91b41520&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-91b41520"]])

export default __exports__